import MobileSliderPagesWrapper from "../components/MobileSliderPagesWrapper";
import PromocodeHelloJetvix from "../../../../modules/Bonus/components/BonusDoubleDeposit/PromocodeHelloJetvix";
import { useCallback, useEffect, useRef } from "react";
import { closeMobileSliderPageAction, openMobileSliderPageAction } from "../../../mobileAppActions";
import { useDispatch } from "react-redux";
import FlashScreen from "../../../../components/FlashScreen/FlashScreen";
import { MOBILE_SLIDER_PAGES_IDS } from "../mobileSliderPagesConstants";
import { logAppsflyerAction } from "../../../../app/appActions";
import { LOG_AF_EVENT_NAMES } from "../../../../app/appConstants";

function SlideMobilePromocodeHelloJetvix() {
    const dispatch = useDispatch();
    const isSendBackButtonEventRef = useRef(true);

    useEffect(() => {
        return () => {
            if (isSendBackButtonEventRef.current) {
                dispatch(logAppsflyerAction({
                    name: LOG_AF_EVENT_NAMES.CASHIER_PROMOCODE_MODAL,
                    payload: { button: 'back' },
                }));
            }
        }
    }, [dispatch]);

    const handleClose = useCallback(() => {
        isSendBackButtonEventRef.current = false;
        dispatch(closeMobileSliderPageAction());
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.CASHIER_PROMOCODE_MODAL,
            payload: { button: 'cross_button' },
        }));
    }, [dispatch]);

    const onTopUpClickHandler = useCallback(() => {
        isSendBackButtonEventRef.current = false;
        dispatch(openMobileSliderPageAction(MOBILE_SLIDER_PAGES_IDS.DEPOSIT));
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.CASHIER_PROMOCODE_MODAL,
            payload: { button: 'top_up' },
        }));
    }, [dispatch]);

    return <MobileSliderPagesWrapper>
        <FlashScreen handleClose={handleClose}>
            <PromocodeHelloJetvix onTopUpClick={onTopUpClickHandler}/>
        </FlashScreen>
    </MobileSliderPagesWrapper>
}

export default SlideMobilePromocodeHelloJetvix;
